
import { Box, Container } from "@mui/material";
import { PrimaryButton } from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Container component="main" className="content-not-found">
      <Box className="main-section">
        <Box className="heading">404 - Page Not Found</Box>
        <Box className="sub-heading">
          It looks like the page you're looking for isn't available. But don't
          worry, we're here to help you get back on track:
        </Box>
        {/* <Box className="action-section">
          <PrimaryButton sx={{ minWidth: "540px" }} onClick={()=>navigate('/dashboard')}>
            View Your Loans
          </PrimaryButton>
        </Box> */}
      </Box>
    </Container>
  );
};

export default NotFound;
